/**
 * Notifications/Index Controller
 *
 * 
 */

// the constructor for this object
function NotificationsIndexController() { }

// the object
NotificationsIndexController.prototype = {
    constructor: NotificationsIndexController,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of order per page
    perPage: 10,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // set up the pagination
        this._setupPagination();
        
        // build the accounts dropdown used in the invoice widget
        this._setupAccountsDropdown();
        
        PortalHelper.debugMessage('Notifications Index Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
    
        // Populate the trouble tickets section
        this._getNotifications();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Notifications Index Controller Ran');
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#notifications-pagination';
        pagination.contentSelector = '#notifications';
        pagination.searchSelector = '#notifications-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.NotificationsIndexController._getNotifications;
        PortalMain.NotificationsIndexController.pagination = pagination;
    },
    
    // build the accounts dropdown used in the invoice widget
    _setupAccountsDropdown: function()
    {
        // populate the accounts dropdown, and rerun the controller on change
        var notificationsAccountSelector =  new PortalAccountSelector();
        notificationsAccountSelector.setupAccountsDropdown(
            '#account-selection',
            function(currentAccountId) {
                PortalHelper.loadingOverlay('#notifications-table', true);
                PortalHelper.loadingOverlay('#notifications-pagination', true);
                
                PortalMain.NotificationsIndexController.pagination.setPage(1);
                
                // get the notifications using the new account id
                PortalMain.NotificationsIndexController._getNotifications();
            }
        );
        this.notificationsAccountSelector = notificationsAccountSelector ;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
    
    },
    
    // get the notifications
    _getNotifications: function()
    {
        // get the submission data from the pagination object
        var submissionData = PortalMain.NotificationsIndexController.pagination.getBaseSubmissionData();
        
        // include the account id with the data
        var currentAccountId = PortalMain.PortalAccounts.getCurrentAccountId();
        if (currentAccountId != 0) {
            submissionData.accountId = currentAccountId;
        }
        
        var notificationsRequest = new PortalRequest;
        notificationsRequest.pageNumber = submissionData.page;
        notificationsRequest.makeRequest(
            '/notifications/get-cmc-notifications',
            submissionData,
            function(data) {
                //handle pagination 
                PortalMain.NotificationsIndexController.pagination.updatePagination(data);
                PortalMain.NotificationsIndexController.pagination.showPagination();
                
                // get the last pagination event
                var lastEvent = PortalMain.NotificationsIndexController.pagination.lastEvent;
                
                PortalMain.NotificationsIndexController._populateNotifications(data.data, lastEvent);
            }
        );
    },
    
    // display the retrieved notifications
    _populateNotifications: function(data, lastPaginationEvent)
    {
        
        // clear the old notifications
        if (lastPaginationEvent != 'more') {
            $('#notifications .notification:not(.clone-source)').remove();
        }
        
        // add the new tickets to the DOM
        for (var i in data) {
            var notification = data[i];
            var newEntry = $('#notifications .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the subject
            $('.subject', newEntry).html(notification.cmc_contact_batch.subject);
            
            // apply the date
            $('.date .value', newEntry).html(notification.cmc_contact_batch.date);
            
            // apply the service affecting
            $('.service-affecting .value', newEntry).html(notification.cmc_contact_batch.service_affecting);
            
            // apply the description
            $('.description .value', newEntry).html(notification.cmc_contact_batch.description_of_work);

            $('.posted', newEntry).attr('data-tooltip', notification.created_readable);
            $('.date-diff', newEntry).html(notification.created_diff_humans);

            // apply the notification link
            var notificationLink = PortalConfig.portalUrl;
            notificationLink += '/notifications/view/' + notification.cmc_contact_email_id;
            $('.box-link', newEntry).attr('href', notificationLink);
           
            // add to the table
            $('#notifications').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#notifications', false);
        PortalHelper.loadingOverlay('#notifications-pagination', false);
    },
    
}